import { IAuthData, VendorClaim } from '@skedulo/horizon-types'

export const generateMockAuthData = (): IAuthData => ({
  idToken: 'idToken',
  profile: {
    iss: 'https://test.skl.io/auth/token',
    aud: 'aud',
    sub: 'auth0|user-1',
    iat: 0,
    exp: 0,
    'https://api.skedulo.com/name': 'Test user',
    'https://api.skedulo.com/user_id': 'auth0|user-1',
    'https://api.skedulo.com/organization_id': 'tenantId',
    'https://api.skedulo.com/username': 'test@skedulo.com',
    'https://api.skedulo.com/resource_id': 'resourceId',
    'https://api.skedulo.com/roles': ['administrator', 'scheduler', 'resource'],
    'https://api.skedulo.com/vendor': VendorClaim.Skedulo,
    'https://api.skedulo.com/ven': { user_id: 'user-1' },
  },
  skedApiAccessToken: 'idToken',
  accessTokenExpiry: 0,
  servers: {
    apiServer: '/apiServer',
    realtimeServer: '/realtimeServer',
    resourceTrackingServer: '/resourceTrackingServer',
    planrServer: '/planrServer',
    pkgrServer: '/pkgrServer',
    packagingServer: '/packagingServer',
    optimizationService: '/optimizationService',
    uiServer: '/ui',
  },
  sfdc: {
    access_token: 'idToken',
    instance_url: '',
  },
})
